/**
 * Generated runtime TestId mirror for frontend/src/components/inbound-connectors/PreviewResultDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const PreviewResultDialogTestIds = {
  btnClosePreview: "btn-close-preview",
  btnDownloadPreview: "btn-download-preview",
  previewBody: "preview-body",
  previewEmpty: "preview-empty",
  previewLoading: "preview-loading",
  previewResultDialog: "preview-result-dialog"
} as const;
